import { createSlice } from "@reduxjs/toolkit";


const initialState: any = {
    reminder: [],
    loading: false,
    error: null,
  };
const reminderSlice = createSlice({
    name: "reminder",
    initialState,
    reducers: {
        reminderRequest(state) {
        state.loading = true;
        state.error = null;
      },
      reminderSuccess(state, action) {
        state.loading = false;
        state.reminder = action.payload;
      },
      reminderAddSuccess(state, action) {
        state.loading = false;
        state.reminder.push(action.payload);
      },
      reminderEditSuccess(state, action) {
        state.loading = false;
        state.reminder = state.reminder.map((reminder: { id: any; }) =>
          reminder.id === action.payload.id ? action.payload : reminder
        );
      },
      reminderDeleteSuccess(state, action) {
        state.loading = false;
        state.reminder = state.reminder.filter((reminder: { id: any; }) => reminder.id !== action.payload);
      },
      reminderError(state, action) {
        state.loading = false;
        state.error = action.payload;
      },
      getReminderByIdRequest(state) {
        state.loading = true;
        state.error = null;
      },
      getReminderByIdSuccess(state, action) {
        state.loading = false;
        state.user = action.payload;  // Store the user fetched by ID in `user`
      },
      getReminderByIdError(state, action) {
        state.loading = false;
        state.error = action.payload;
      },
    },
  });

  export const {
      reminderRequest,
      reminderSuccess,
      reminderAddSuccess,
      reminderEditSuccess,
      reminderDeleteSuccess,
      reminderError,
      getReminderByIdRequest,
      getReminderByIdSuccess,
      getReminderByIdError
  } = reminderSlice.actions;

export default reminderSlice.reducer;
  